import { render, staticRenderFns } from "./registration-segment-region.vue?vue&type=template&id=db4db624&scoped=true"
import script from "./registration-segment-region.vue?vue&type=script&lang=ts"
export * from "./registration-segment-region.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4db624",
  null
  
)

export default component.exports